import { HOME_CRUMBS } from "../../constants/crumbs";
import PortalBreadcrumb from "../UI/Breadcrumb/PortalBreadcrumb/PortalBreadcrumb";
import PricedOrdersSection from "./PricedOrdersSection/PricedOrdersSection";
import PendingOrdersSection from "./PendingOrdersSection/PendingOrdersSection";
import Banner from "./Banner/Banner";
import CategoriesSection from "./CategoriesSection/CategoriesSection";
import NewlyAddedSkusSlider from "./NewlyAddedSkusSlider/NewlyAddedSkusSlider";
import MobileApplicationSection from "./MobileApplicationSection/MobileApplicationSection";
import classes from "./Home.module.css";

const Home = () => {
  return (
    <div className={classes["home"]}>
      <PortalBreadcrumb paths={HOME_CRUMBS} />
      <PricedOrdersSection />
      <PendingOrdersSection />
      <Banner />
      <CategoriesSection />
      <NewlyAddedSkusSlider />
      <MobileApplicationSection />
    </div>
  );
};

export default Home;
